var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLtBadge = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 .565-.014 16.998c.001.333-.022.666-.069.997a5.437 5.437 0 0 1-.454 1.541c-.666 1.406-1.45 2.238-2.197 2.948-1.502 1.428-2.994 2.151-4.019 2.637A19.026 19.026 0 0 1 10.498 27a19.017 19.017 0 0 1-3.748-1.314c-1.024-.486-2.517-1.209-4.019-2.637-.747-.71-1.531-1.542-2.194-2.948a5.42 5.42 0 0 1-.454-1.541 7.037 7.037 0 0 1-.07-.997L0 .565h21zm-1.071 1.469H1.07l.013 15.109c0 .296.02.592.062.886.066.473.203.934.407 1.37.596 1.25 1.3 1.989 1.97 2.62 1.35 1.27 2.69 1.912 3.61 2.344a17.19 17.19 0 0 0 3.365 1.169 17.185 17.185 0 0 0 3.367-1.169c.92-.432 2.26-1.074 3.609-2.344.67-.631 1.374-1.37 1.973-2.62a4.8 4.8 0 0 0 .407-1.37c.042-.294.063-.59.062-.886l.013-15.109zm-1.262 1.469-.011 13.22c0 .26-.017.518-.054.775a4.232 4.232 0 0 1-.353 1.2c-.518 1.092-1.128 1.74-1.709 2.291-1.168 1.112-2.329 1.674-3.126 2.052-.93.44-1.908.783-2.916 1.022a14.788 14.788 0 0 1-2.914-1.022c-.797-.378-1.958-.94-3.126-2.052-.582-.552-1.192-1.199-1.707-2.292a4.216 4.216 0 0 1-.353-1.199 5.477 5.477 0 0 1-.054-.775l-.01-13.22h16.333z",
    fill: "#FAD44E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.585 17.565a.183.183 0 0 1-.183-.183V6.75c0-.102.082-.184.183-.184h1.822c.101 0 .183.082.183.184v10.633a.183.183 0 0 1-.183.183H9.585zm-4.402-4.41A.183.183 0 0 1 5 12.973V11.15c0-.1.082-.183.183-.183h10.634c.1 0 .183.082.183.183v1.822a.183.183 0 0 1-.183.184H5.183z",
    fill: "#FFF"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLtBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lt-badge.c4dfecd5.svg";
export { ForwardRef as ReactComponent };